export default "<div id=\"{{chartId}}\" style=\"height:400px;\"></div>";